import {ObjectTypeId} from "./object-type-id";


export class ObjectTypeIdList {

    _list: ObjectTypeId[];

    constructor() {
        this._list = [];
    }

    public addList(addList: ObjectTypeIdList) {
        if (addList) {

            addList._list.forEach(value => {
                this.add(value);
            });

        }
    }

    public add(objectTypeId: ObjectTypeId) {
        this._list[objectTypeId.getUniqueId()] = objectTypeId;
    }

    public has(objectTypeId: ObjectTypeId) : boolean {
        if (this._list[objectTypeId.getUniqueId()]) {
            return true;
        } else {
            return false;
        }
    }

    public hasObjectTypeId(objectType: string, objectId: number) : boolean {

        const objectTypeId = new ObjectTypeId(objectType, objectId);

        if (this._list[objectTypeId.getUniqueId()]) {
            return true;
        } else {
            return false;
        }
    }




}
